module.exports = __webpack_public_path__ + "media/images/amenities_icons/coffee_cup-de884dee28a9857a30263919ccb680da.svg";